import { render, staticRenderFns } from "./Error403.vue?vue&type=template&id=b7ad9a0a&scoped=true&"
import script from "./Error403.vue?vue&type=script&lang=ts&"
export * from "./Error403.vue?vue&type=script&lang=ts&"
import style0 from "./Error403.vue?vue&type=style&index=0&id=b7ad9a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ad9a0a",
  null
  
)

export default component.exports